import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { NGXLogger } from "ngx-logger";
import { map } from "rxjs/operators";
import { environment } from "../../../environments/environment";
import { I18nService } from "../../shared/services";
import { PagerService } from "./pager.service";

@Injectable()
export class ListingsService extends PagerService {
  private spotBuildingIdsAPI: string = `/spotbuildings/search/ids/fast`;
  private spotBuildingDetailsAPI: string = `/spotbuildings/search/detail`;
  private advertisements: string =
    "api/service-provider/carousel-data?application=SIILA";

  private loadedListings = [];
  totalCount: number = 0;
  currentPage: number = 1;
  pageSize: number = 5;
  latamCountry = "";

  constructor(
    private http: HttpClient,
    private _log: NGXLogger,
    private i18nService: I18nService
  ) {
    super();
  }

  public get getCurrentPage(): number {
    return this.currentPage;
  }

  public get getTotalPageCount(): number {
    return this.totalCount;
  }

  async getListings() {
    let payload = { isFeaturedWithoutCheckingDate: true, randomOrder: true };
    const { body: ids }: { body: number[] } = (await this.searchSpotBuildingIds(
      payload,
      1
    )) as { headers: HttpHeaders; body: number[] };
    let spotBuildingList: any = await this.getSpotBuildingDetails(
      1,
      ids.length,
      ids
    );
    return spotBuildingList;
  }

  async searchSpotBuildingIds(searchRequest: any, page: number) {
    let urlSearchParams = new URLSearchParams();
    urlSearchParams.append("page", page.toString());
    urlSearchParams.append("per_page", "4");
    urlSearchParams.append("lang", this.i18nService.getCurrentLanguage());
    const host =
      this.latamCountry == "latamMx"
        ? environment.apiURLMX
        : this.latamCountry == "latamBr"
        ? environment.apiURLBR
        : environment.apiURL;

    return await this.http
      .post(
        host + this.spotBuildingIdsAPI + "?" + urlSearchParams,
        searchRequest,
        {
          observe: "response"
        }
      )
      .pipe(
        map(val => {
          return {
            headers: val.headers,
            body: val.body
          };
        })
      )
      .toPromise();
  }

  async getSpotBuildingDetails(
    page: number,
    pageSize: number,
    spotBuildingIds: number[]
  ): Promise<any[]> {
    let params = "";

    let detailsURL =
      (this.latamCountry == "latamMx"
        ? environment.apiURLMX
        : this.latamCountry == "latamBr"
        ? environment.apiURLBR
        : "/api") +
      `${this.spotBuildingDetailsAPI}?page=${page}&per_page=${pageSize}${params}`;

    return await this.http
      .post(detailsURL, spotBuildingIds)
      .toPromise()
      .then((response: any[]) => {
        const listings = response;
        return listings;
      });
  }

  getAdvertisements(size?: number) {
    if (size) {
      return this.http
        .get(this.advertisements + (size ? "&size=" + size : ""), {
          observe: "response"
        })
        .pipe(map(val => val.body));
    } else {
      return this.http
        .get(this.advertisements, {
          observe: "response"
        })
        .pipe(map(val => val.body));
    }
  }

  async getActiveListingDetails() {
    return null;
  }

  public setTotalCount(totalCountHeader: string) {
    if (!totalCountHeader) {
      return;
    }
    this.totalCount = parseInt(totalCountHeader);
  }

  public appendListings(listings: any[]) {
    this.loadedListings = [...this.loadedListings, ...listings];
  }

  fetchPage(page) {
    console.error("fetchPage not implemented in ListingsService");
  }
}
